// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ird: CountryValidator<"NZ"> = createValidator(
  "nz.ird",
  140,
);

export default ird;
export const compact = ird.compact;
export const format = ird.format;
export const validate = ird.validate;
export const generate = (): string =>
  ird.generate?.() ??
  (() => {
    throw new Error(
      "Validator nz.ird cannot generate values",
    );
  })();
